module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--fr-94f046c0bcb03e780f745840ad94e2c6.jpg";